<template>
	<a
		class="js-scroll-top md:hidden fixed bottom-24 right-4 z-30 bg-gradient-to-l from-btnGradient1 to-btnGradient2 p-4 rounded-lg shadow-lg"
		:class="{ 'hidden': inactive }"
		@click.prevent="scrollToTop()"
		href="#"
	>
		<svg class="-rotate-90" xmlns="http://www.w3.org/2000/svg" width="8" height="18" viewBox="0 0 8 18">
			<path fill="#fff" fill-rule="nonzero" d="M.119.718l7.158 7.407-.033-.551-6.737 8.889a.425.425 0 0 0 .08.593.42.42 0 0 0 .59-.08l6.737-8.889a.425.425 0 0 0-.033-.551L.723.128A.42.42 0 0 0 .128.12a.425.425 0 0 0-.009.598z"/>
		</svg>
	</a>
</template>
<script>
export default {
	data: () => ({
		inactive: true,
	}),
	methods: {
		toggleScrollToTopButton() {
			let scrolled = window.scrollY;

			if( scrolled > 1000 ){
				this.inactive = false;
			} else {
				this.inactive = true;
			}
		},
		scrollToTop() {
			window.scroll({top: 0, behavior: "smooth"});
		},
	},
	created() {
		document.addEventListener("scroll", () => {
			this.toggleScrollToTopButton()
		})
	},
}
</script>